import { IConfiguration } from '../../config/IConfiguration';

export class ConfigProvider {
  private static config: IConfiguration;

  static get(): IConfiguration {
    if (!this.config) this.setupConfig();

    return this.config;
  }

  static setupConfig() {
    this.config = globalThis.BahfConfig;
  }

  static isMockLoginAllowed() {
    // @ts-ignore
    return '__allow_mock_login__' === 'allow';
  }
}
